import Layout from './Layout';

import { RatingSendForm } from './RatingSendForm';
import { ReviewSendForm } from './ReviewSendForm';
import { AfterLowRatingSentPage } from './AfterLowRatingSentPage';
import { AfterHighRatingSentPage } from './AfterHighRatingSentPage';
import { ValidationPage } from './ValidationPage';
import { NotFound } from '@/components/Pages/Errors/NotFound';

import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export enum PageName {
  Validation = 'VALIDATION',
  Rating = 'RATING',
  Review = 'REVIEW',
  AfterLow = 'AFTERLOW',
  AfterHigh = 'AFTERHIGH',
  Invalid = 'INVAILD'
}

export type ReservationInfo = {
  reserveId: string;
  outpatientId: string;
  reservationDate: string;
  startTime: string;
};

export function ReviewForm() {
  const [activePage, setActivePage] = useState(PageName.Validation);
  const [rating, setRating] = useState(0);

  const [searchParams] = useSearchParams();
  const reserveId = searchParams.get('reserveId');
  const outpatientId = searchParams.get('outpatientId');
  const reservationDate = searchParams.get('reservationDate');
  const startTime = searchParams.get('startTime');

  if (reserveId == null || outpatientId == null || reservationDate == null || startTime == null) {
    return <NotFound />;
  }

  const reservationInfo: ReservationInfo = {
    reserveId: reserveId,
    outpatientId: outpatientId,
    reservationDate: reservationDate,
    startTime: startTime
  };

  const toReviewPage = (rating: number) => {
    setActivePage(PageName.Review);
    setRating(rating);
  };

  switch (activePage) {
    case PageName.Validation:
      return (
        <Layout title="">
          <ValidationPage setActivePage={setActivePage} reservationInfo={reservationInfo} />
        </Layout>
      );
    case PageName.Rating:
      return (
        <Layout title="ご来院ありがとうございました">
          <RatingSendForm setActivePage={setActivePage} toReviewPage={toReviewPage} reservationInfo={reservationInfo} />
        </Layout>
      );
    case PageName.Review:
      return (
        <Layout title="来院後のご感想">
          <ReviewSendForm setActivePage={setActivePage} rating={rating} reservationInfo={reservationInfo} />
        </Layout>
      );
    case PageName.AfterLow:
      return (
        <Layout title="ご評価ありがとうございました">
          <AfterLowRatingSentPage />
        </Layout>
      );
    case PageName.AfterHigh:
      return (
        <Layout title="ご評価ありがとうございました">
          <AfterHighRatingSentPage />
        </Layout>
      );
    default:
      return <NotFound />;
  }
}

export default ReviewForm;
